import { render, staticRenderFns } from "./DialogRecycleBin.vue?vue&type=template&id=3f1a8c28&scoped=true"
import script from "./DialogRecycleBin.vue?vue&type=script&lang=js"
export * from "./DialogRecycleBin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1a8c28",
  null
  
)

export default component.exports